export type RetryOptions = {
    retries?: number;
    interval?: number;
    backoffExponent?: number;
};

// Based on https://github.com/gregberge/loadable-components/issues/667
// const Example = loadable(() => retry(() => import('./Example'), { retries: 3 }));
export function retry<R>(
    fn: () => Promise<R>,
    { retries = 3, interval = 500, backoffExponent = 1 }: RetryOptions = {}
) {
    return new Promise<R>((resolve, reject) => {
        fn()
            .then(resolve)
            .catch((error) => {
                console.warn(`Chunk failed to load, retrying. Attempts left: ${retries}.`, error);
                setTimeout(() => {
                    if (retries === 1) {
                        reject(error);
                        return;
                    }

                    // Passing on "reject" is the important part. `backoffExponent` must be passed
                    // on too: without it the recursive call falls back to the default of 1, so the
                    // interval multiplies exactly once and then goes flat. routes.tsx asks for
                    // { retries: 3, interval: 500, backoffExponent: 2 }, which should back off
                    // 500 -> 1000 -> 2000, but waited 500 -> 1000 -> 1000 — a third less time for a
                    // transient blip to clear before the route chunk is abandoned.
                    retry(fn, {
                        retries: retries - 1,
                        interval: interval * backoffExponent,
                        backoffExponent,
                    }).then(resolve, reject);
                }, interval);
            });
    });
}
